import { IonIcon, IonItem, IonLabel } from "@ionic/react";
import { mailOutline } from "ionicons/icons";
import React from "react";
import { Template } from "../../../@types/template";

interface Props {
  template: Template;
}

export const TemplateListItem: React.FC<Props> = ({ template }) => {
  return (
    <IonItem
      routerLink={`/app/tic/plantillas/detalle/${template.id}`}
      class="ion-margin-bottom"
      lines="none"
      detail
    >
      <IonLabel>
        <h2 style={{ fontWeight: 500 }}>{template.name}</h2>
        <h4>
          <IonIcon icon={mailOutline} />
        </h4>
      </IonLabel>
    </IonItem>
  );
};
